import { AltchaState } from '@/state'

export const altchaStateActions = {
  setAltcha: (altcha: string) => {
    AltchaState.altcha.value = altcha
  },
}
